export const computeFloatingMenuPosition = (buttonElement, menuWidth = 210, gap = 6, viewportPadding = 8) => {
  const rect = buttonElement.getBoundingClientRect();
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  // Prefer opening directly below the trigger (left-aligned), then clamp into viewport.
  const preferredLeft = rect.left;
  const maxLeft = Math.max(viewportPadding, viewportWidth - menuWidth - viewportPadding);
  const left = Math.min(Math.max(viewportPadding, preferredLeft), maxLeft);

  return {
    top: Math.max(viewportPadding, rect.bottom + gap),
    left,
  };
};

export const resolveToggledMenuId = (currentMenuId, nextMenuId) => {
  return Number(currentMenuId) === Number(nextMenuId) ? null : nextMenuId;
};
